import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import type { AppStatus } from './types';
import { checkHealth, checkReady } from './api';
import SeedManager from './components/SeedManager';
import BatchManager from './components/BatchManager';
import BatchResults from './components/BatchResults';
import Sidebar from './components/Sidebar';
import TagManager from './components/TagManager';

const App: React.FC = () => {
  const [status, setStatus] = useState<AppStatus>({ health: false, ready: false });

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const [healthRes, readyRes] = await Promise.all([
          checkHealth().catch(() => ({ status: 'unhealthy' })),
          checkReady().catch(() => ({ status: 'not ready' })),
        ]);
        setStatus({
          health: healthRes.status === 'ok',
          ready: readyRes.status === 'ok',
        });
      } catch {
        setStatus({ health: false, ready: false });
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100%', overflow: 'hidden' }}>
      <Sidebar status={status} />
      <main style={{ flex: 1, padding: 20, boxSizing: 'border-box', overflowY: 'auto' }}>
        <div style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <Routes>
            <Route path="/" element={<Navigate to="/seeds" replace />} />
            <Route path="/seeds" element={<SeedManager />} />
            <Route path="/seeds/:seedId" element={<SeedManager />} />
            <Route path="/batches" element={<BatchManager />} />
            <Route path="/batches/:batchId" element={<BatchResults />} />
            <Route path="/batches/:batchId/sessions/:sessionId" element={<BatchResults />} />
            <Route path="/tags" element={<TagManager />} />
            <Route path="*" element={<Navigate to="/seeds" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default App;
